import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { useApi } from "../../hooks/useApi.jsx";
import { GridContainerFlex } from "../../components/layout/GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import { GridItemFlex } from "../../components/layout/GridFlex/GridItemFlex/GridItemFlex.jsx";
import {HomeLayout} from "./layout/HomeLayout.jsx";
export const Home = () => {
    const { api, callApi } = useApi();

    const onThrow = async (code) => {
        await callApi({
            request: async () => {
                return await api.throwError(code);
            },
        });
    };

    return (
        <HomeLayout>
            <GridContainerFlex justifyContent={"center"}>
                <GridItemFlex xs={12}>
                    <GridContainerFlex justifyContent={"space-evenly"}>
                        {[400, 401, 403, 404, 422, 503, 500, 999].map((code) => (
                            <GridItemFlex key={code}>
                                <Button onClick={() => onThrow(code)}>Throw {code}</Button>
                            </GridItemFlex>
                        ))}
                    </GridContainerFlex>
                </GridItemFlex>
            </GridContainerFlex>
        </HomeLayout>
    );
};
